// extracted by mini-css-extract-plugin
export var chevron = "_2a-2";
export var chevronCollapsed = "_2a-3";
export var collapsibleHeader = "_2a-1";
export var container = "_2a-0";